import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-vehicle-score',
  templateUrl: './vehicle-score.component.html',
  styleUrls: ['./vehicle-score.component.css']
})
export class VehicleScoreComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  scoreData: any;
  isloader: boolean = true;
  isError: boolean = false;
  private _getScoreDetailsSubscription: Subscription;

  
  constructor(private _service: EntitiesServiceService) { }

  ngOnInit(): void {
    // this.getTileData();
  }
  ngOnDestroy(): void {
    this._getScoreDetailsSubscription?.unsubscribe();
  }
  ngOnChanges() {
    if (this.entityId)
      this._getScoreData();
  }

  private _getScoreData() {
    this._getScoreDetailsSubscription = this._service.getScoreDetails({ entityId: this.entityId }).subscribe(
      {
        next: (result: any) => {
          if (result.status) {
            this.scoreData = result.response.data[0];
            this.isloader = false;
          }
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }
}
